import { useSaleOperationLoaders } from "../../sales"
import { useCashFundLoaders } from "../loaders/cashFundLoaders"
import { useCreditPaymentLoaders } from "../loaders/creditPaymentLoaders"
import { usePaymentOrderLoaders } from "../loaders/paymentOrderLoaders"
import { usePaymentTypeLoaders } from "../loaders/paymentTypeLoaders"
import { useTransactionLoaders } from "../loaders/transactionLoaders"

export const useCashFundHooks = () => {
    const cashFundLoaders = useCashFundLoaders()
    const creditPaymentLoaders = useCreditPaymentLoaders()
    const saleOperationLoaders = useSaleOperationLoaders()
    const paymentOrderLoaders = usePaymentOrderLoaders()
    const paymentTypeLoaders = usePaymentTypeLoaders()
    const transactionLoaders = useTransactionLoaders()

    const canRemoveCashFund = async (cashFundId: string): Promise<boolean> => {
        const { loadCashFund } = cashFundLoaders()
        const cashFund = await loadCashFund(cashFundId, true)

        const { countCreditPayments } = creditPaymentLoaders()
        const creditPaymentsCount = await countCreditPayments('destinationId', cashFundId)
        
        const { loadSaleOperationsWithProp } = saleOperationLoaders()
        const saleOperationsWithPaymentItems = await loadSaleOperationsWithProp('paymentItems', true)
        const saleOperations = saleOperationsWithPaymentItems.filter(saleOperation => saleOperation.paymentItems.some(paymentItem => paymentItem.destinationId === cashFundId))

        const { loadPaymentOrdersWithProp } = paymentOrderLoaders()
        const paymentOrdersWithPaymentItems = await loadPaymentOrdersWithProp('paymentItems', true)
        const paymentOrders = paymentOrdersWithPaymentItems.filter(paymentOrder => paymentOrder.paymentItems.some(paymentItem => paymentItem.sourceId === cashFundId))
        
        const { loadAllPaymentTypes } = paymentTypeLoaders()
        const allPaymentTypes = await loadAllPaymentTypes()
        const paymentTypes = allPaymentTypes.filter(paymentType => paymentType.cashFundIds.includes(cashFundId))
        
        const { countTransactions } = transactionLoaders()
        const sourceTransactionsCount = await countTransactions('sourceId', cashFundId)
        const destinationTransactionsCount = await countTransactions('destinationId', cashFundId)
        const transactionsCount = sourceTransactionsCount + destinationTransactionsCount

        return cashFund!.availableAmount === 0 &&
            cashFund!.reservedAmount === 0 &&
            creditPaymentsCount === 0 &&
            saleOperations.length === 0 &&
            paymentOrders.length === 0 &&
            paymentTypes.length === 0 &&
            transactionsCount === 0
    }

    return {
        canRemoveCashFund
    }
}
